var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "#4079F5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 3.92856C6.96832 3.92856 3.24054 6.64364 1.73022 10.4762C3.24054 14.3087 6.96832 17.0238 11.3334 17.0238C15.6985 17.0238 19.4263 14.3087 20.9366 10.4762C19.4263 6.64364 15.6985 3.92856 11.3334 3.92856ZM11.3334 14.8413C8.92387 14.8413 6.96832 12.8857 6.96832 10.4762C6.96832 8.06665 8.92387 6.1111 11.3334 6.1111C13.7429 6.1111 15.6985 8.06665 15.6985 10.4762C15.6985 12.8857 13.7429 14.8413 11.3334 14.8413ZM11.3334 7.85713C9.88419 7.85713 8.71435 9.02697 8.71435 10.4762C8.71435 11.9254 9.88419 13.0952 11.3334 13.0952C12.7826 13.0952 13.9524 11.9254 13.9524 10.4762C13.9524 9.02697 12.7826 7.85713 11.3334 7.85713Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3a54686200c631dbbb63489d2be3f041.svg";
export { ForwardRef as ReactComponent };